module.exports = require("@swa-ui/itinerary/src/ItineraryStations/ItineraryStations.module.scss");